import { render, staticRenderFns } from "./register-person-rol.vue?vue&type=template&id=326895cc&scoped=true&"
import script from "./register-person-rol.vue?vue&type=script&lang=js&"
export * from "./register-person-rol.vue?vue&type=script&lang=js&"
import style0 from "./register-person-rol.vue?vue&type=style&index=0&id=326895cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326895cc",
  null
  
)

export default component.exports